<template>
  <div class="pt-side-menu-group">
    <template v-for="item in items">
      <a
        :key="item.key"
        class="pt-side__item"
        :class="{
          'is-active': activeKey === item.key,
          'has-children': item.children && item.children.length
        }"
        :style="{ paddingLeft: (16 + level * 16) + 'px' }"
        @click="onItemClick(item)"
      >
        <span class="pt-side__item-label" >{{ item.label }}</span>
        <span
          v-if="item.children && item.children.length"
          class="pt-side__toggle"
          :class="{ 'is-expanded': !collapsedKeys[item.key] }"
          @click.stop="onToggle(item.key)"
        />
      </a>

      <!-- 递归子级 -->
      <side-menu-item
        v-if="item.children && item.children.length && !collapsedKeys[item.key]"
        :key="item.key + '_sub'"
        :items="item.children"
        :level="level + 1"
        :active-key="activeKey"
        :collapsed-keys="collapsedKeys"
        @go-section="onGoSection"
        @toggle-collapse="onToggle"
        @parent-click="onParentClick"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'SideMenuItem',
  props: {
    items: { type: Array, default: function () { return [] } },
    level: { type: Number, default: 0 },
    activeKey: { type: String, default: '' },
    collapsedKeys: { type: Object, default: function () { return {} } }
  },
  methods: {
    onItemClick: function (item) {
      if (item.href) {
        window.location.href = item.href
        return
      }
      if (item.children && item.children.length) {
        this.$emit('parent-click', item)
      } else {
        this.$emit('go-section', item)
      }
    },
    onToggle: function (key) {
      this.$emit('toggle-collapse', key)
    },
    onGoSection: function (item) {
      this.$emit('go-section', item)
    },
    onParentClick: function (item) {
      this.$emit('parent-click', item)
    }
  }
}
</script>

<style lang="less" scoped>
/* 菜单项（窄屏单行胶囊，桌面竖向） */
.pt-side__item {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  background: #f3f5f8;
  color: #333;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.pt-side__item:hover {
  color: #0a447c;
}
.pt-side__item.is-active {
  background: #0a447c;
  color: #fff;
}
.pt-side__item-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 收起/展开箭头 */
.pt-side__toggle {
  flex: none;
  width: 16px;
  height: 16px;
  position: relative;
  transition: transform 0.2s;
}
.pt-side__toggle::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #999;
}
.pt-side__toggle.is-expanded::after {
  transform: translate(-50%, -50%) rotate(0deg);
}

/* ===== 桌面端：竖向菜单 ===== */
@media (min-width: 768px) {
  .pt-side__item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 13px 16px 13px 22px;
    border-radius: 0;
    border-left: 3px solid transparent;
    background: transparent;
    border-bottom: 1px solid #f2f4f7;
    white-space: normal;
  }
  .pt-side__item:hover {
    background: #f5f8fc;
    color: inherit;
  }
  .pt-side__item.is-active {
    background: #eef4fb;
    border-left-color: #e8873a;
    color: #0a447c;
    font-weight: 600;
  }
}
</style>
